@if (form; as form) {
  <form [formGroup]='form' autocomplete='off' novalidate>
    <fieldset>
      <div class='row'>
        <div class='col-12'>
          <legend>{{ label }}</legend>
        </div>
      </div>
      <br>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              Data od *
            </label>
            <app-date-picker (change)="form.startDateChange($event)" [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"endDate" as controlName'>
            <label [for]='controlName'>
              Data do *
            </label>
            <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-4">
          <div class='form-group' *ngIf='"dayQuantity" as controlName'>
            <label [for]='controlName'>
              Ilość dni
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu ilość dni'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <fieldset>
            <legend>
              Dane reklamy
            </legend>
            <div class="row">
              <div class="col-md-4">
                <div class='form-group' *ngIf='"adKind" as controlName'>
                  <label [for]='controlName'>Rodzaj reklamy *</label>
                  <select
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [id]='controlName'
                    [formControlName]='controlName'>
                    <option value=''>Wybierz</option>
                    <option value='Reklama trwale związana z gruntem'>Reklama trwale związana z gruntem</option>
                    <option value='Reklama nietrwale związana z gruntem'>Reklama nietrwale związana z gruntem</option>
                  </select>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
              <div class="col-md-4">
                <div class='form-group' *ngIf='"adLightingType" as controlName'>
                  <label [for]='controlName'>Oświetlenie reklamy *</label>
                  <select
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [id]='controlName'
                    [formControlName]='controlName'>
                    <option value=''>Wybierz</option>
                    <option value='Podświetlana'>Podświetlana</option>
                    <option value='Niepodświetlana'>Niepodświetlana</option>
                    <option value='Swietlna'>Swietlna</option>
                  </select>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
              <div class="col-md-4">
                <div class='form-group' *ngIf='"adType" as controlName'>
                  <label [for]='controlName'>Typ reklamy *</label>
                  <select
                    (change)="form.adTypeChange()"
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [id]='controlName'
                    [formControlName]='controlName'>
                    <option value=''>Wybierz</option>
                    <option value='Jednostronna'>Jednostronna</option>
                    <option value='Dwustronna'>Dwustronna</option>
                  </select>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
              <div class="col-md-6">
                <div class='form-group' *ngIf='"adMountingStructure" as controlName'>
                  <label [for]='controlName'>
                    Konstrukcja mocowania reklamy *
                  </label>
                  <input
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu nazwę konstrukcji'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
            </div>
            <div formArrayName="purposeFees">
              @for (feeForm of form.purposeFeesForms; track $index) {
                <fieldset>
                  <div class='row' [formGroup]="feeForm">
                    <div class='col-md-3'>
                      <div class='form-group' *ngIf='"width" as controlName'>
                        <label [for]='controlName'>
                          Szerokość reklamy (m) *
                        </label>
                        <input
                          (change)='feeForm.calcArea(form.adType.value === "Dwustronna")'
                          mask='separator.2'
                          decimalMarker=','
                          [dropSpecialCharacters]='false'
                          [id]='controlName'
                          [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                          [formControlName]='controlName'
                          placeholder='Wpisz tu szerokość'
                          type='text'>
                        <app-validation-errors [control]='feeForm.get(controlName)'>
                        </app-validation-errors>
                      </div>
                    </div>
                    <div class='col-md-3'>
                      <div class='form-group' *ngIf='"length" as controlName'>
                        <label [for]='controlName'>
                          Długość reklamy (m) *
                        </label>
                        <input
                          (change)='feeForm.calcArea(form.adType.value === "Dwustronna")'
                          mask='separator.2'
                          decimalMarker=','
                          [dropSpecialCharacters]='false'
                          [id]='controlName'
                          [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                          [formControlName]='controlName'
                          placeholder='Wpisz tu długość'
                          type='text'>
                        <app-validation-errors [control]='feeForm.get(controlName)'>
                        </app-validation-errors>
                      </div>
                    </div>
                    <div class='col-md-3'>
                      <div class='form-group' *ngIf='"quantity" as controlName'>
                        <label [for]='controlName'>
                          Ilość (szt) *
                        </label>
                        <input
                          (change)='feeForm.calcArea(form.adType.value === "Dwustronna")'
                          mask='0*'
                          [id]='controlName'
                          [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                          [formControlName]='controlName'
                          placeholder='Wpisz tu ilość'
                          type='text'>
                        <app-validation-errors [control]='feeForm.get(controlName)'>
                        </app-validation-errors>
                      </div>
                    </div>
                    <div class='col-md-3'>
                      <div class='form-group' *ngIf='"area" as controlName'>
                        <label [for]='controlName'>
                          Łączna powierzchnia reklamy (m<sup>2</sup>)
                        </label>
                        <input
                          mask='separator.2'
                          decimalMarker=','
                          [dropSpecialCharacters]='false'
                          [id]='controlName'
                          [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                          [formControlName]='controlName'
                          placeholder='Powierzchnia'
                          type='text'>
                        <app-validation-errors [control]='feeForm.get(controlName)'>
                        </app-validation-errors>
                      </div>
                    </div>
                  </div>
                </fieldset>
              }
            </div>
          </fieldset>
        </div>
      </div>
      <br>
      <app-exposed-map-control #mapControl [control]="form.geometry">
      </app-exposed-map-control>
      <app-road-controls-set [expMapDict]="mapControl.dictEvent()" [form]="form"></app-road-controls-set>
    </fieldset>
    <fieldset>
      <legend>
        Działki
      </legend>
      <div class="row">
        <div class="col-12">
          <app-parcels-crud [expMapDict]="mapControl.dictEvent()" formControlName="parcels"></app-parcels-crud>
        </div>
      </div>
    </fieldset>
  </form>
}
